








import {Product} from "@/model/product";
import {ProductItemState} from "@/model/product-item-state";
import {ProductCollection} from "@/service/product";
import {Util} from "@/util/util";
import Vue from "vue";
import {ProductPriceStock} from "@/model/product-price-stock";
import {ActionCollection} from "@/service/action-collection";
import {Action} from "@/model/action";
import {DiscountQuantityCollection} from "@/service/discount-quantity-collection";

export default Vue.extend({
    name: "OrderableProductBase",
    props: {
        productKey: {
            type: String,
            required: true
        },
        position: {
            type: Number,
            default: 0
        },
        location: {
            type: String,
            default: ""
        },
        columns: {
            type: Array,
            default: []
        },
        actionCollection: {
            type: Object as () => ActionCollection,
            required: false,
            default() {
              return new ActionCollection()
            }
        },
        quantityDiscountCollection: {
            type: Object as () => DiscountQuantityCollection,
            required: false,
            default() {
                return new DiscountQuantityCollection()
            }
        },
        showGrossPrice: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        productKey(): void {
            this.refresh();
        },
        pps() : void {
            // reload actions and quantity discounts upon every PPS change
            this.actions = [];
            this.quantityDiscounts = [];
            
            if (this.pps == null) return;
            
            // reload actions
            if (this.pps.actions && this.pps.actions.length > 0) {
                this.pps.actions.forEach(id => {
                        this.$props.actionCollection.get(id).then((action: Action) => this.actions.push(action));
                        this.$forceUpdate();
                    }
                )
            }
            
            // reload quantity discounts
            if (this.pps.quantityDiscounts && this.pps.quantityDiscounts.length > 0) {
                this.pps.quantityDiscounts.forEach(id => {
                        this.$props.quantityDiscountCollection.get(id).then((action: Action) => this.quantityDiscounts.push(action));
                        this.$forceUpdate();
                    }
                )
            }
        }
    },
    data() {
        return <{
            product: Product | null,
            pps: ProductPriceStock | null, actions: Action[],
            quantityDiscounts: Action[],
            visibleProductActions: string[]
        }>{
            product: null,
            pps: null,
            actions: [],
            quantityDiscounts: [],
            visibleProductActions: []
        };
    },
    created() {
        this.refresh();
    },
    computed: {
        displayState(): string {
            if (Util.isLoggedIn() == false)
                return ProductItemState.NOT_LOGGED_IN;
            
            if (this.product == null || this.pps == null)
                return ProductItemState.LOGGED_IN_NOT_LOADED;
            
            if (this.product.isOrderable(this.pps.totalStock, this.pps.itemBaseNetPrice, this.pps.priceOnRequest))
                return ProductItemState.LOGGED_IN_LOADED_ORDER_ABLE;
            
            else if (this.product.showPriceOnly(this.pps.totalStock, this.pps.itemBaseNetPrice, this.pps.priceOnRequest))
                return ProductItemState.LOGGED_IN_NOT_ORDERABLE_SHOW_PRICE_ONLY;
            
            return ProductItemState.LOGGED_IN_LOADED_NO_ORDER_ABLE;
        },
        
        canShowAction(): boolean {
            return this.visibleProductActions.includes(this.$props.productKey);
        },
    },
    methods: {
        refresh() {
            ProductCollection
                .getInstance()
                .getProduct(this.$props.productKey)
                .then(product => {
                    this.product = product;
                    this._refreshPriceStockInformation();
                });
        },
        
        _refreshPriceStockInformation() {
            if (Util.isLoggedIn() && null != this.product) {
                this.product
                    .getPriceAndStocks()
                    .then(data => {
                        this.pps = data.pps;
                    });
            }
        },
        
        addVisibleProductAction() {
            if (this.visibleProductActions.includes(this.$props.productKey) == false) {
                this.visibleProductActions.push(this.$props.productKey);
            }
        },
        
        removeVisibleProductAction() {
            const index = this.visibleProductActions.indexOf(this.$props.productKey);
            if (index > -1) {
                this.visibleProductActions.splice(index, 1);
            }
        },
    }
});
